<template>
    <PrivacyNoticeDialog v-model:open="isOpen" />
    <button type="button" :disabled="disabled" class="button button-text button-text--muted" @click="isOpen = true">
        {{ displayLabel }} <i class="bi bi-lock" aria-hidden="true" />
    </button>
</template>

<script setup>
import PrivacyNoticeDialog from "~vue/Onboarding/PrivacyNoticeDialog.vue";
import { computed, inject, ref } from "vue";

const props = defineProps({
    disabled: Boolean,
    buttonText: { type: String, default: "Privacy" },
});
const isOpen = ref(false);
const organizationDetails = inject("organization_details");
const displayLabel = computed(() => organizationDetails?.value?.privacy_link_label || props.buttonText);
</script>
